import React, { useState } from "react"
import styled from "styled-components"
import { Card } from "../../atoms"
import useDeviceTheme from "@project/shared/src/useDeviceTheme"

export interface ISoftwareSolutionCard {
  icon: React.ReactNode
  lightIcon?: React.ReactNode
  title: string
  content: string
}
const IconOuterStyle = styled.div`
  border-radius: 15px 15px 20px 20px;
  padding-top: 1px;
  background-image: ${(props) => props.theme.highlightGradient};
`
const IconStyle = styled.div`
  background: ${(props) => props.theme.iconBackgroundGradient};
  border-radius: 15px;
  border: 1px solid ${(props) => props.theme.solftwareSolutionBorderColor};
  padding: 12px;
  img {
    height: 50px;
    width: 50px;
    @media (max-width: 1023px) {
      height: 32px;
      width: 32px;
    }
  }
`

const CardWrapper = styled(Card)`
  position: relative;
  padding: 40px 30px;
  min-height: 350px;
  height: auto;
  max-width: 410px;
  width: 100%;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  color: ${(props) => props.theme.base};
  @media (max-width: 1350px) {
    max-width: 100%;
    width: 100%;
    padding: 20px;
  }
  @media (max-width: 600px) {
    padding: 24px;
    min-height: auto;
  }
  &:hover {
    background-color: ${(props) => props.theme.highlightGradient};
    & > .icon-outer > .icon-inner {
      background: ${(props) => props.theme.highlightGradient};
    }
    & > .icon-outer {
      background: transparent;
    }
    & > .card-line {
      display: none;
    }
  }
`

const CardOuterDiv = styled.div`
  position: absolute;
  top: -1px;
  left: 0px;
  right: 0px;
  height: 20px;
  border-radius: 50px;
  background: ${(props) => props.theme.highlightGradient};
  z-index: -1;
`

const TextStyle = styled.div`
  ${(props) => props.theme.typography.paragraph2}
  font-size: 14px;
  min-height: 105px;
  font-weight: 400;
  margin-top: 8px;
  text-align: center;
  white-space: break-spaces;
  color: ${(props) => props.theme.whiteAlpha60};
`
const TitleStyle = styled.div`
  ${(props) => props.theme.typography.cardTitle}
  font-weight: 600;
  margin-top: 20px;
  text-align: center;
  font-size: 18px;
  white-space: break-spaces;
  color: ${(props) => props.theme.sneakPeakTitleColor};
  @media (max-width: 1023px) {
    font-size: 1rem;
  }
  @media (max-width: 600px) {
    margin-top: 16px;
  }
`
const StyledCardWrapper = styled.div`
  border-radius: 56px 56px 56px 56px;
  padding-top: 0px;
  background-image: ${(props) => props.theme.highlightGradient};

  &:hover {
    border-radius: 50px 50px 56px 56px;
    padding-top: 1px;
  }
`

export const SoftWareSolutionCard: React.FC<ISoftwareSolutionCard> = ({
  icon,
  content,
  title,
  lightIcon,
}) => {
  const isDarkTheme = useDeviceTheme()
  const [isHovered, setIsHovered] = useState<boolean>(false)

  const handleMouseEnter = () => setIsHovered(true)

  const handleMouseLeave = () => setIsHovered(false)
  return (
    <StyledCardWrapper
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <CardWrapper>
        <CardOuterDiv />
        {/* <CardLine className={"card-line"}></CardLine> */}
        <IconOuterStyle className={"icon-outer"}>
          <IconStyle className={"icon-inner"}>
            {isDarkTheme || isHovered ? icon : lightIcon}
          </IconStyle>
        </IconOuterStyle>
        <TitleStyle>{title}</TitleStyle>
        <TextStyle>{content}</TextStyle>
      </CardWrapper>
    </StyledCardWrapper>
  )
}
